<script setup lang="ts">
import type { Blocks, BreadcrumbListItem, ContentResponseContent, Metadata } from 'types';

const props = defineProps<{
  blocks: Blocks;
  content: ContentResponseContent;
  breadcrumbs: BreadcrumbListItem[];
  metadata: Metadata;
}>();

const computedBlocks = computed(() => {
  return props.blocks.blocks || {};
});
</script>

<template>
  <section>
    <BlockList
      v-if="computedBlocks"
      :blocks="computedBlocks"
    />
  </section>
</template>
